module.exports = __webpack_public_path__ + "img/goals.06193bc2.svg";